import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import AuthService from "../../services/AuthService";
import Login from '../../pages/Login';
import {  MemberLinkBtnOrangeDark } from '../../styles/Elements';
export default class DisabledUsers extends Component {

  state = {
    disabledUsers: []
  }



  componentDidMount() {
    this.refreshDataUsers();
  }


  refreshDataUsers() {
   const loggedInUser = AuthService.getCurrentUser();
   const whatRole = AuthService.getUserRole();
   if( !loggedInUser || (whatRole === ('USER')) || whatRole === ('MODERATOR')) {} else {

     AuthService.getDisabledUsers()
      .then(res => {
        const disabledUsers = res.data;
        this.setState({ disabledUsers });
      })
    } 
  }


  
  enableMemberClicked(username) {
  
    AuthService.enableUser(username)
        .then((response) => {
            this.refreshDataUsers();
            window.location.reload();
        })
        .catch((err) => {
        });
}

  render() {
const loggedInUser = AuthService.getCurrentUser();
const whatRole = AuthService.getUserRole();
    return (
      <div className="wrapper-admin-inactive-users">
      { !loggedInUser || (whatRole === ('USER')) || whatRole === ('MODERATOR') ? 
      <div>
        <Login></Login>
      </div> :
      <div className="admin-board-inactive">
        { !(this.state.disabledUsers.length < 1) ?
        <div>   
{this.state.disabledUsers.map(user => (
      <div className="inactive-list" key={user.id}>
        <h3> Username : {user.username}</h3>
        <h3> Email : {user.email}</h3>
       <button className="activate-btn" onClick={() => this.enableMemberClicked(user.username)}> Activate </button>
      </div>
))}
      </div> :
     <div className="inactive-list">
       <h3>Empty Inactive List !</h3>
     </div> }
   
    </div>
    
  }
  <MemberLinkBtnOrangeDark to='/adminboard/'> Back to Admin Board </MemberLinkBtnOrangeDark>
  </div>
  )
     
}}